import { useQuery, gql } from "@apollo/client"

const useStudentsPendingLessons = (vars = {}, options = {fetchPolicy: 'no-cache'}) => {
    const userQuery = `
        id
        firstName
        lastName
        avatar
        studentInfo {
            parents {
                parentUserId
                managePayments
                manageApprovals
                firstName
                lastName
            }
        }
    `
    return useQuery(
        gql`
            query {
                studentsPendingLessons {
                    pendingLessons {
                        ${userQuery}
                        tasksForWidget {
                            id
                            title
                            educator {
                                firstName
                                lastName
                            }
                            substitute {
                                firstName
                                lastName
                            }
                            endDate
                        }
                    }
                    general {
                        ${userQuery}
                        tasksForWidget {
                            id
                            title
                            educator {
                                firstName
                                lastName
                            }
                            substitute {
                                firstName
                                lastName
                            }
                            endDate
                        }
                    }
                }
            }
        `,{
            variables: vars,
            ...options
        }
    )
}

export default useStudentsPendingLessons